import { Injectable } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';
import { Observable,of as observableOf } from 'rxjs';

/**
 * Custom strategy that only preloads routes whose data.preload flag is set to true.
 * */
@Injectable()
export class SelectivePreloadingStrategy implements PreloadingStrategy {

  /**
   * The router calls the preload method with two arguments.
   *
   * @param route The route to consider
   * @param load A loader function that can load the routed module asynchronously
   * @return If the route should preload, it returns the observable returned by calling the loader function. If the
   * route should not preload, it returns an Observable of null.
   * */
  preload(route: Route, load: () => Observable<any>): Observable<any> {
    return route.data && route.data.preload ? load() : observableOf(null);
  }
}
